import { Injectable } from '@angular/core';
import { 
  HttpInterceptor, HttpRequest, 
  HttpHandler, HttpErrorResponse, HttpEvent 
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorService } from '../error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router, private errorService: ErrorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
        let message = 'An unexpected error occurred.';

        switch (error.status) {
            case 0:
            message = 'Cannot connect to server.';
            this.errorService.setError({ statusCode: 0, message, path: req.url });
            break;
            case 401:
            return throwError(() => error);
            case 403:
            message = 'You do not have permission.';
            this.router.navigate(['/not-authorized']);
            break;
            case 404:
            message = 'Resource not found.';
            this.errorService.setError({ statusCode: 404, message, path: req.url });
            break;
            case 500:
            message = 'A server error occurred.';
            this.errorService.setError({ statusCode: 500, message, path: req.url });
            this.router.navigate(['/error'], {
                state: { statusCode: 500, message }
            });
            break;
            default:
            message = error.error?.message || error.message || message;
            this.errorService.setError({ statusCode: error.status, message, path: req.url });
        }

        return throwError(() => error);
        })
        );
    }
}